import { useEffect } from 'react';
import { useCart } from '@backpackjs/storefront';
import { useScriptLoad } from './hooks';
import { useAnalytics } from './FueledAnalytics';
import { TRACKING_EVENTS } from './fueled.events';

const EVENTS = [TRACKING_EVENTS.REMOVE_FROM_CART, TRACKING_EVENTS.ADD_TO_CART];

export function FueledFondueCashbackScript() {
  const cart = useCart();
  const { register, subscribe } = useAnalytics();
  const ready = register('fondue-cashback-script');

  const { status } = useScriptLoad(
    {
      id: 'fondue-cashback-script',
      src: 'https://public.getfondue.com/cashback-extension/cart/fundle.js',
      shop: 'kryo-gear.myshopify.com',
      api: 'STOREFRONT',
      waitFor: () => !!window.Fondue,
    },
    'head'
  );

  useEffect(() => {
    if (status !== 'ready' || !cart?.id) return;

    window.Fondue.cart.getCartId = function () {
      return cart?.id;
    };
    window.getCartId = function () {
      return cart?.id;
    };
    window.Fondue.cart.registerCartId(cart.id);
  }, [cart?.id, status]);

  useEffect(() => {
    if (status !== 'ready') return;

    const updateCartListener = () => {
      // Delay to ensure dl_add_to_cart is fully processed
      if (window.Fondue.status === 'ready') {
        window.Fondue.cart.dispatchUpdatedCartEvent();
      }

      console.log('fondueCashback update Cart Event Fired');
    };

    const unsubscribeArray = EVENTS.map((event) =>
      subscribe(event, updateCartListener)
    );

    ready();

    // eslint-disable-next-line consistent-return
    return () => {
      unsubscribeArray.forEach((unsubscribe) => unsubscribe());
    };
  }, [status]);

  return null;
}
